import isEmpty from 'lodash-es/isEmpty';
import React from 'react';
import { Dashboard } from '@components';
import { HeadContent, Pagination, usePagination } from '@fourthwall/components';
import { routing } from '@utils/routing';
import { GiftCardsData } from './components/GiftCardsData/GiftCardsData';
import { useGiftCards } from './hooks/useGiftCards';
import { useFilterGiftCards } from './modules/GiftCardsFilter';
export const GiftCards = () => {
    const { tableProps } = useGiftCards();
    const [currentPage, setCurrentPage] = usePagination();
    const { hasFilterParams } = useFilterGiftCards();
    const getEmptyStateProps = () => {
        if (hasFilterParams) {
            return {
                title: 'No gift cards found',
                subtitle: 'Adjust your filters.',
            };
        }
        return {
            title: 'You haven’t create any gift cards yet',
            subtitle: 'Digital gift cards can be applied at checkout on any order. Any unused balance remains available for future purchases.',
            label: 'Create gift card',
            to: routing.promotions.giftCards.create.self,
        };
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(HeadContent, { title: "Gift cards" }),
        React.createElement(Dashboard.Section.Item, null,
            React.createElement(GiftCardsData, { data: tableProps.data, isLoading: tableProps.isLoading, emptyStateProps: getEmptyStateProps() })),
        !isEmpty(tableProps.data) && tableProps.totalPages > 0 && (React.createElement(Dashboard.Section.Item, null,
            React.createElement(Pagination, { pageCount: tableProps.totalPages, currentPage: currentPage, onChange: setCurrentPage })))));
};
